import { ReactNode } from "react";
import styled from "@emotion/styled/macro";
import { tokens, Typography } from "@sunrun/experience-ui-components";
import { useCheckoutContext } from "../../providers/CheckoutContext";
import { UtilityBillRequiredForFinalApprovalBanner } from "./UtilityBillRequiredForFinalApprovalBanner";

type CheckoutHeaderProps = {
  headerTitle: string;
  subtitle?: ReactNode;
  isMobile?: boolean;
  offerLabel?: string;
  showUtilityBillUploadRequirementBanner?: boolean;
};

const CheckoutHeader = ({
  headerTitle,
  isMobile,
  offerLabel,
  showUtilityBillUploadRequirementBanner,
}: CheckoutHeaderProps) => {
  const { navigateToTask } = useCheckoutContext();
  return (
    <CheckoutPageHeader>
      <InnerHeader
        isMobile={isMobile}
        showUtilityBillUploadRequirementBanner={
          showUtilityBillUploadRequirementBanner
        }
      >
        <Typography
          variant="h1"
          color={tokens.BRAND_HERO_BLUE}
          lineHeight={isMobile ? tokens.FONT_SIZE_6 : tokens.FONT_SIZE_10}
          size={isMobile ? tokens.FONT_SIZE_6 : tokens.FONT_SIZE_7}
          fontWeight="medium"
        >
          {headerTitle}
        </Typography>
        {showUtilityBillUploadRequirementBanner && (
          <StyledBannerContainer
            showUtilityBillUploadRequirementBanner={
              showUtilityBillUploadRequirementBanner
            }
            isMobile={isMobile}
          >
            <UtilityBillRequiredForFinalApprovalBanner
              onClickPrimaryAction={() => navigateToTask("linkUtilityAccount")}
              showIcon={false}
            />
          </StyledBannerContainer>
        )}
        {isMobile && (
          <Typography
            variant="h2"
            color={tokens.BRAND_HERO_BLUE}
            size={tokens.FONT_SIZE_0}
            fontWeight="regular"
          >
            Solar offer: {offerLabel}
          </Typography>
        )}
      </InnerHeader>
    </CheckoutPageHeader>
  );
};

const CheckoutPageHeader = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
`;

const StyledBannerContainer = styled.div<{
  isMobile?: boolean;
  showUtilityBillUploadRequirementBanner?: boolean;
}>`
  max-width: 50%;
  ${({ isMobile, showUtilityBillUploadRequirementBanner }) =>
    isMobile &&
    showUtilityBillUploadRequirementBanner &&
    `
    padding: 8px 0;
    max-width: 100%;
    width: 100%;
  `}
`;

const InnerHeader = styled.div<{
  isMobile?: boolean;
  showUtilityBillUploadRequirementBanner?: boolean;
}>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: start;
  flex-direction: column;
  gap: ${(props) => (props.isMobile ? "4px" : "16px")};
  ${(props) =>
    props.showUtilityBillUploadRequirementBanner &&
    `
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  `}

  ${({ isMobile, showUtilityBillUploadRequirementBanner }) =>
    isMobile &&
    showUtilityBillUploadRequirementBanner &&
    `
    flex-direction: column;
    align-items: start;
  `}
`;

export { CheckoutHeader };
export type { CheckoutHeaderProps };
